import React from 'react'
import { useQuery } from 'react-query'
import useComapnyCode from '@/hooks/useComapnyCode'
import request from '@/services'
import toQueryString from '@/utils/toQueryString'
import { downloadFile } from '@/utils/webHelper'

const useExportQuery = (apiUrl: string, query: any, options: any) => {
  const companyCode = useComapnyCode({ supportSystemAdminCode: true })
  const { isNotSupportAdmin, ...otherOptions } = options
  return useQuery(
    [apiUrl, query],
    () => {
      return request(
        `${isNotSupportAdmin ? '' : `/${companyCode}`}${apiUrl}?${toQueryString(query)}`,
        {
          method: 'GET',
          headers: {},
        }
      )
    },
    {
      enabled: !!query,
      ...otherOptions,
    }
  )
}

export function useExportFile(
  {
    filename,
    apiUrl,
    extension,
    isNotSupportAdmin = false,
    onSuccess,
  }: {
    filename: string
    apiUrl: string
    extension?: string
    isNotSupportAdmin?: boolean
    onSuccess?: () => void
  }
) {
  const [querys, setQuerys] = React.useState<Record | undefined>(undefined)
  const [incrementCount, setIncrementCount] = React.useState(0)

  const exportSuccess = (data: Blob) => {
    downloadFile({
      blob: data,
      filename,
      extension,
      onSuccess,
    })
  }

  const { isLoading } = useExportQuery(apiUrl, querys, {
    isNotSupportAdmin,
    onSuccess: (data: any) => {
      exportSuccess(data)
    },
  })

  const exportFile = (querys: Record | undefined) => {
    setQuerys({
      ...querys,
      incrementCount,
    })
    setIncrementCount(k => ++k)
  }

  return {
    exportFile,
    isExporting: isLoading,
  }
}
